import {
  CREATE_SITE_WEATHER_CONFIGURATION,
  DELETE_SITE_WEATHER_CONFIGURATION,
  EDIT_SITE_WEATHER_CONFIGURATION,
  RECEIVE_SITE_WEATHER_CONFIGURATIONS,
  REQUEST_SITE_WEATHER_CONFIGURATION,
  REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE,
} from '@sophocles/entities/SiteWeatherConfiguration/siteWeatherConfigurationActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_WEATHER_CONFIGURATIONS: // Read
      return state.merge(action.siteWeatherConfigurations);
    case DELETE_SITE_WEATHER_CONFIGURATION: // Delete
      return state.delete(action.siteWeatherConfiguration.toString());
    case EDIT_SITE_WEATHER_CONFIGURATION: // Update
    case CREATE_SITE_WEATHER_CONFIGURATION: // Create
    case REQUEST_SITE_WEATHER_CONFIGURATION:
    case REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE:
    default:
      return state;
  }
}

export function siteWeatherConfigurationReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SITE_WEATHER_CONFIGURATION:
    case DELETE_SITE_WEATHER_CONFIGURATION:
    case RECEIVE_SITE_WEATHER_CONFIGURATIONS:
    case EDIT_SITE_WEATHER_CONFIGURATION:
    case REQUEST_SITE_WEATHER_CONFIGURATION:
    case REQUEST_SITE_WEATHER_CONFIGURATION_FOR_SITE:
      return getState(state, action);
    default:
      return state;
  }
}
